const registerStatus = [
  { title: 'Có đi', value: true },
  { title: 'Không đi', value: false }
]

export { registerStatus }
